import { OpenAPI } from '../controller/datamanager/api.js'
async function getToFixed(code) {
  const point = sessionStorage.getItem(`${code}_point`);
  if (!point) {
  } else {
    return Number(point)
  }
  const lastSymbol = code.slice(code.lastIndexOf('.') + 1);
  const preSymbol = code.substring(0, code.lastIndexOf('.'));
  // const market_summer = await OpenAPI.market_summer({ mic: lastSymbol });
  // const rstSummer = market_summer.data.finance_mic_grp[0];
  /* const wizard = await OpenAPI.wizard({ prod_code: preSymbol, en_finance_mic: lastSymbol });
  const rstWizard = wizard.data[0].hq_type_code;
  const beforeName = rstSummer.finance_mic;
  const { type_grp } = rstSummer;
  const hq_type_code = type_grp.filter(item => beforeName + '.' + item.hq_type_code == rstWizard) */
  // return new Promise((resolve, reject) => {
  //   resolve(hq_type_code[0].px_precision)
  // });
  sessionStorage.setItem(`${code}_point`, 2)//hq_type_code[0].px_precision)
  return hq_type_code[0].px_precision;
}
export default {
  getToFixed
}
